import { cn } from '@mntn-dev/ui-utilities'
import type { SkeletonProps } from './types.ts'

const Skeleton = ({
  children,
  className,
  style,
  variant = 'rounded',
}: SkeletonProps) => {
  return (
    <div
      className={cn(
        'skeleton-line w-full',
        variant === 'rounded' && 'rounded-lg',
        className
      )}
      style={style}
    >
      {children}
    </div>
  )
}

export { Skeleton }
